import React from "react";
import Registration from "../components/auth/registration";

const Signup = () => {
  return <Registration />;
};

export default Signup;
